// The workspace this console works in until the server says otherwise. The signed in person's real
// workspaces come from GET /api/me (hooks/access-model.js); this constant is the label shown while that
// answer is not connected, and the default pick when the person holds Clairvos.
export const CURRENT_WORKSPACE = Object.freeze({ id: 'clairvos', label: 'Clairvos' })

export const DEFAULT_WORKSPACE_ID = CURRENT_WORKSPACE.id

// Names for the workspace ids Engine knows. An id with no entry is shown as the id itself.
export const WORKSPACE_LABELS = Object.freeze({ clairvos: 'Clairvos', 'data-brokerage': 'Data Brokerage' })

export const workspaceLabel = id => WORKSPACE_LABELS[id] || String(id)
